export default function App() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-100">
      <div className="px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="flex items-center gap-3 mb-10">
          <div className="w-1 h-7 bg-primary-500 rounded-full"></div>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-100">
            移动端入口
          </h2>
        </div>

        <div className="bg-background-200 rounded-2xl overflow-hidden">
          <div className="flex flex-col lg:flex-row items-center gap-0">
            <div className="flex-1 p-6 md:p-10 lg:p-12">
              <h3 className="font-heading text-xl md:text-2xl font-bold text-foreground-200 mb-3">
                暗网吃瓜 · 随时随地吃最新鲜的瓜
              </h3>
              <p className="text-sm md:text-base text-foreground-500 leading-relaxed mb-6">
                下载暗网吃瓜移动客户端，第一时间接收黑料推送通知，不再错过任何劲爆的新爆料和隐秘八卦。移动端支持暗黑模式、离线阅读和吃瓜群快捷入口，让你在通勤、排队、睡前都能畅快吃瓜。
              </p>

              <div className="flex flex-col sm:flex-row items-center gap-3">
                <div className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-6 py-3 bg-background-100 rounded-xl text-foreground-400 cursor-pointer hover:bg-background-300 transition-colors">
                  <i className="ri-apple-fill text-xl"></i>
                  <div className="text-left">
                    <div className="text-xs text-foreground-600">Download on the</div>
                    <div className="text-sm font-medium whitespace-nowrap">App Store</div>
                  </div>
                </div>

                <div className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-6 py-3 bg-background-100 rounded-xl text-foreground-400 cursor-pointer hover:bg-background-300 transition-colors">
                  <i className="ri-android-fill text-xl"></i>
                  <div className="text-left">
                    <div className="text-xs text-foreground-600">GET IT ON</div>
                    <div className="text-sm font-medium whitespace-nowrap">Google Play</div>
                  </div>
                </div>

                <div className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-6 py-3 bg-background-100 rounded-xl text-foreground-400 cursor-pointer hover:bg-background-300 transition-colors">
                  <i className="ri-qr-code-line text-xl"></i>
                  <div className="text-left">
                    <div className="text-xs text-foreground-600">或扫描</div>
                    <div className="text-sm font-medium whitespace-nowrap">二维码下载</div>
                  </div>
                </div>
              </div>
            </div>

            <div className="w-full lg:w-[320px] flex justify-center p-6 lg:p-0 lg:pr-10">
              <div className="relative w-48 h-80 md:w-56 md:h-96">
                <img
                  src="https://readdy.ai/api/search-image?query=Dark%20mobile%20phone%20mockup%20showing%20a%20mysterious%20social%20feed%20app%20interface%20with%20red%20and%20dark%20theme%2C%20gossip%20and%20news%20style%20content%20cards%2C%20modern%20UI%20design%2C%20dark%20mode%20smartphone%20screen%2C%20clean%20minimal%20layout%20with%20crimson%20accent%20colors%2C%20product%20mockup%20photography&width=560&height=960&seq=app-mockup&orientation=portrait"
                  alt="暗网吃瓜移动端App界面"
                  className="w-full h-full object-cover rounded-2xl"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}